export default __webpack_public_path__ + "static/media/cert-cpttm.891d3fff.jpg";